"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var DirectChat_1 = require("./DirectChat");
exports.default = DirectChat_1.default;
//# sourceMappingURL=index.js.map